import { Component, EventEmitter, Input, OnInit, DoCheck, Output, ApplicationRef  } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { CvOrdinalLocalizePipe } from 'src/app/reusables/pipes/cv-ordinal-localize.pipe';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { BadgeSelectorComponent } from 'src/app/reusables/badge-selector/badge-selector.component';
import { cloneDeep } from 'lodash';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';

@Component({
  selector: 'cv-configure-rewards-bullseye',
  templateUrl: './configure-rewards-bullseye.component.html',
  styleUrls: ['./configure-rewards-bullseye.component.scss']
})
export class ConfigureRewardsBullseyeComponent implements OnInit, DoCheck {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  complete: boolean = false;
  selectedRing: any = {};
  editing: boolean;
  rewardType: any;
  rewardValue: number;
  rings: Ring[] = [];
  nextPlaceText: string = "";
  showBadgeSelector: boolean;
  showRemove = [];
  oldBadgeSelected: number = 0;
  modalReference: any;

  //Variables to help measure the text to resize the textboxes accordingly. styleString should match the style that is set for the element
  minTextBoxSize: number = 40;          //The smallest the textbox can be (minus the breatheSpace)
  maxTextBoxSize: number = 200;         //The largest the textbox can be (plus the breathSpace)
  breatheSpace: number = 10;            //The space that is added after measuring the text. This is essentially padding
  styleString: string = "60px roboto";  //Match to the style of the element that is being measured
  isCxone = false;

  constructor(
    private modalService: NgbModal,
    private gamesService: GamesService,
    private dialogService: CvDialogService,
    private ordinalPipe: CvOrdinalLocalizePipe,
    private navigationService: NavigationService,
    private formattedMetricPipe: GenericMetricFormatterPipe,
    private appRef: ApplicationRef,
    public cvConfigurationService: CvConfigurationService,
    private customDialogService: CvCustomDialogService,
  ) { 
    this.gs = this.gamesService.data;
    $(document).on("Event.Games.Setup.MetricClicked", this.onMetricClicked);
  }

  ngOnInit(): void {
    this.gs.modified.item.BullseyeRewards = this.gs.modified.item.BullseyeRewards || [this._newRingTemplate()];
    this.rings = this.gs.modified.item.BullseyeRewards;

    for (var i = 0; i < this.rings.length; i++) {      
      this.showRemove.push(false);

      if (this.rings[i] != null && this.rings[i].ComparisonType != null)
        this.rings[i].ComparisonType = this.rings[i].ComparisonType.toString();
    }
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  ngDoCheck(): void {
    if(this.selectedRing != null && this.selectedRing.Badge != null && this.selectedRing.Badge.rewardValue != this.oldBadgeSelected){
      this.oldBadgeSelected = this.selectedRing.Badge.rewardValue;
      this.checkIfComplete();
    }
  }

  handleVal1ModelChange (index: number, value: string) {
    // First, we need to check if the input value has only the allowed characters.
    // Allowed characters are: numbers from 0 to 9, ; and .
    // If input value has one or more invalid character, we change value
    // to a random number and trigger change detection just to assign a calculated number later.
    // We do this because if the calculated value is the same as the current, change detection
    // is not going to be fired with the correct value
    if (!this.isValidRingValue(value)) {
      this.rings[index].Target.Val1 = +Date.now().toString(36);
      this.appRef.tick();
    }

    // Now, let's get the numeric version of the input value
    // and set it to the ring val. This will be auto-updated by angular in UI
    // after a while.
    const numericValue = this.getRingNumericValue(value);
    this.rings[index].Target.Val1 = numericValue

    // If the updated ring is not the first one, we should calculate
    // if input value is between limits stablished by the rule (ComparisonType)
    if (index > 0) {
      // If the limited value is the same as the input value,
      // we don't have the need to update the value. Otherwise,
      // let's force the app change detection and assign the correct value
      // to the ring
      const previousVal1 = this.rings[index - 1].Target.Val1;
      const currentValue2 = this.rings[index].Target.Val2;
      const limitValue = this.getRingLimitValue(previousVal1, numericValue, currentValue2);

      if (limitValue != numericValue) {
        this.appRef.tick();
        this.rings[index].Target.Val1 = limitValue
      }
    }

    // At the end, we have to re-calculate subsequents input to make sure
    // they are between the new limits
    if (this.rings.length > 1)
      this.recalculateSubsequentsRingsValue(index);
  }

  _newRingTemplate (ComparisonType = "1") {
    return {
      Coins: this._newRewardTemplate(this.gs.rewardOptions.Coins),
      XP: this._newRewardTemplate(this.gs.rewardOptions.XP),
      Currency: this._newRewardTemplate(this.gs.rewardOptions.Currency),
      Badge: this._newRewardTemplate(this.gs.rewardOptions.Badge),
      Target: {
        Val1: 0,
        Val2: 0
      },
      ComparisonType
    }
  }

  _newRewardTemplate (type: number) {
    return {
      editing: false,
      rewardType: type,
      rewardValue: 0
    }
  }

  openMoreRingsInfoBox (modalTemplate) {
    this.navigationService.showOverlay = true;
    this.modalReference = this.modalService.open(modalTemplate, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    this.modalReference.result.finally(() => {
      this.navigationService.showOverlay = false;
    });
  }

  addNextRing () {
        const newRingTemplate = this._newRingTemplate(ComparisonType.Between);
        const isLessThan = this.rings[0].ComparisonType == ComparisonType.LessThan;
        const isGreaterThan = this.rings[0].ComparisonType == ComparisonType.GreaterThan;
        const prevVal1 = this.rings[this.rings.length - 1].Target.Val1;
        const step = this.getRingsStep();
        const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;

        let ringSecondValue, ringFirstValue;

        if (conversionType === '4') {
            if (isLessThan) {
                ringSecondValue = this.addOffset(conversionType, prevVal1);
                ringFirstValue = this.addOffset(conversionType, prevVal1 + step);
            } else if (isGreaterThan) {
                ringSecondValue = this.substractOffset(conversionType, prevVal1);
                ringFirstValue = this.substractOffset(conversionType, ringSecondValue - step);
            }
        } else {
            ringSecondValue = isLessThan ? this.addOffset(conversionType, prevVal1) : this.substractOffset(conversionType, prevVal1);
            ringFirstValue = isGreaterThan ? this.substractOffset(conversionType, ringSecondValue) : this.addOffset(conversionType, ringSecondValue);
        }

        newRingTemplate.Target.Val1 = this.getRingNumericValue(
            this.formattedMetricPipe.transform(ringFirstValue, conversionType)
        );
        newRingTemplate.Target.Val2 = ringSecondValue;

        this.rings.push(newRingTemplate);
    }

  _setAllVal1FieldsToZero () {
    this.rings[0].Target.Val1 = 0;
    this.appRef.tick();
    this.recalculateSubsequentsRingsValue();
  }

  recalculateVal2Fields () {
        const isLessThan = this.rings[0].ComparisonType == ComparisonType.LessThan;
        const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;

        for (let i = 1; i < this.rings.length; i++) {
            const v1 = this.rings[i - 1].Target.Val1;
            const ringSecondValue = isLessThan ? this.addOffset(conversionType, v1) : this.substractOffset(conversionType, v1);
            if (v1 != null && !isNaN(v1)) {
                this.rings[i].Target.Val2 = ringSecondValue;  //The unformatted value is used directly
            }
        }
    }

  /**
   * Loops through rings array and update their Val1 and Val2 starting from next ring index. 
   * 
   */
  recalculateSubsequentsRingsValue (start = 0) {
        for (let i = start + 1; i < this.rings.length; i++) {
            const prevVal1 = this.rings[i - 1].Target.Val1;

            if (prevVal1 != null && !isNaN(prevVal1)) {
                const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;
                const isLessThan = this.rings[0].ComparisonType == ComparisonType.LessThan;

                const currentValue1 = isLessThan ? this.addOffset(conversionType, prevVal1) : this.substractOffset(conversionType, prevVal1);
                const ringSecondValue = isLessThan ? this.addOffset(conversionType, prevVal1) : this.substractOffset(conversionType, prevVal1);

                this.rings[i].Target.Val1 = currentValue1;  // Keep in seconds
                this.rings[i].Target.Val2 = ringSecondValue;  // Keep in seconds without formatting
            }
        }
    }

  removeRing (ring, $index) {
    if (ring.RuleLevelID > 0) { //already saved to db
      if (this.gs.modified.item.RemovedRuleLevelIDs == null)
        this.gs.modified.item.RemovedRuleLevelIDs = [];
      this.gs.modified.item.RemovedRuleLevelIDs.push(ring.RuleLevelID);
    }

    this.rings.splice(this.rings.indexOf(ring), 1);
    this.nextPlaceText = this.ordinalPipe.transform(this.rings.length + 1);
    this.recalculateVal2Fields();
  }

  confirmRemoveRing(ring, $index) {
    if (this.rings == null || this.rings.length < 2) {
      // Don't allow removing of the last level
      const errorTitle = this.gamesService.getLocalizedMessage("Action_Not_Allowed", "Action Not Allowed");
      const errorMessage = this.gamesService.getLocalizedMessage("Top_Dog_Remove_Level_Failed", "Cannot remove the last reward ring in this game.");
  
      if (this.cvConfigurationService.isCxOne) {
        const modalOptions: NgbModalOptions = {
          keyboard: false,
          backdrop: 'static',
          centered: true,
          windowClass: 'cxone-create-game-validation-modal'
        };

        this.customDialogService.showDialog(
          errorTitle,
          errorMessage,
          13,
          '',
          this.gamesService.getLocalizedMessage("Ok", "Ok"),
          true,
          () => {}, // No action on close
          () => {}, // No action on OK
         'cxone-create-game-validation-modal-style',
          true,
          modalOptions
        );
      } else {
        showErrorMessage(errorMessage, errorTitle);
      }
      return;
    }
  
    const title = this.gamesService.getLocalizedMessage("Confirm_Remove", "Confirm Remove");
    const message = this.gamesService.getLocalizedMessage("Remove_Bullseye_Ring", "Are you sure you want to remove this ring? This operation cannot be undone.");
  
    if (this.cvConfigurationService.isCxOne) {
      const modalOptions: NgbModalOptions = {
        keyboard: false,
        backdrop: 'static',
        centered: true,
        windowClass: 'cxone-create-warning-modal'
      };
  
      this.customDialogService.showDialog(
        title,
        message,
        11,
        this.gamesService.getLocalizedMessage("Cancel", "Cancel"),
        this.gamesService.getLocalizedMessage("Ok", "Ok"),
        true,
        () => { this.removeRing(ring, $index); },
        () => {},
        'cxone-modal-game-warning',
        true,
        modalOptions
      );
    } else {
      this.dialogService.showConfirmDialog(
        title, message, false, () => { this.removeRing(ring, $index); }
      );
    }
  }

  popBadgeSelector (ring): void {
    this.showBadgeSelector = true;
    this.selectedRing = ring;

    const modalRef = this.modalService.open(BadgeSelectorComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    //Sending input value
    modalRef.componentInstance.header = this.gamesService.getLocalizedMessage("Select_Badge", "Select your badge");
    modalRef.componentInstance.showWhen = this.showBadgeSelector;
    modalRef.componentInstance.showCustomBadge = !this.isCxone;

    //Catching event answer
    modalRef.componentInstance.onBadgeSelected.subscribe(result => {
      this.selectedRing.Badge.rewardValue = result;
      modalRef.close();
    });
  }

  removeBadge (badge) {
    badge.rewardValue = 0;
  }

  getPopoverTemplate(badgeID: number): string {
    return "<div class='glaeBadgePopover'><img src=\"../Admin/ImageResizer.aspx?imgid=" + badgeID + "&w=128&h=128\" /></div>"
  }

  //Hide the textbox on click off
  handleBlur ($event, rewardItem) {
    var $elem = $($event.target);
    var resetToZero = false; //If the box is empty or invalid, should the value reset to zero?
    if ($elem != null) {
      var val = parseFloat($elem[0].value);
      if (val == null || isNaN(val)) {
        resetToZero = true;
      }
    }

    rewardItem.editing = false;

    if (resetToZero) { //If resetToZero happened, the box needs to be re-measured
      rewardItem.rewardValue = 0;
      this.fitElemToVal($elem);
    }

    this.checkIfComplete();
  }

  handleRewardBlur ($event) {
    var $elem = $($event.target);
    var resetToZero = false;
    if ($elem != null) {
      var val = parseFloat($elem[0].val);
      if (val == null || isNaN(val))
        resetToZero = true;
    }

    if (resetToZero)
      $elem[0].val = "0";

    this.checkIfComplete();
  }

  handleComparisonTypeChanged () {
    this.recalculateVal2Fields();
  }

  checkIfComplete () {
    if (!this.complete) {
      //Check each ring to see if anything is set at all. If so, set complete to true
      if (this.rings != null) {
        this.rings.forEach((ring) => {
          if (ring.Coins.rewardValue > 0 || ring.XP.rewardValue > 0 || ring.Currency.rewardValue > 0 || ring.Badge.rewardValue > 0) {
            this.complete = true;

            //Fire one time event to unlock the next component
            var eventArgs = {
              currentStep: this.step - 1,
              unlocks: this.componentOptions.unlocks
            };

            this.componentComplete.emit(eventArgs);
            return;
          }
        });
      }
    }
  }

  //Resizes the box to fit the value based on the variables set above
  fitElemToVal ($elem) {
    var textWidth = this.getTextWidth($elem.val(), this.styleString);
    textWidth = Math.max(this.minTextBoxSize, textWidth + this.breatheSpace);
    textWidth = Math.min(this.maxTextBoxSize - this.breatheSpace, textWidth);
    textWidth += this.breatheSpace;
    $elem.width(textWidth);
  }

  //https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
  getTextWidth(text, font) {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return Math.round(metrics.width);
  }

  getTimeInSeconds(value: string) {
    const valueSplited = value.split(":").map(v => +v);
    let i = valueSplited.length - 3;

    const hour = +valueSplited[0] || 0;
    const minutes = +valueSplited[1] || 0;
    const seconds = +valueSplited[2] || 0;
    return hour * 3600 + minutes * 60 + seconds;
  }

    getRingNumericValue(value: string) {
        const CT = this.gs.modified.item.SelectedMetrics[0].conversionType;

        // If the metric is time-based (ConversionType = 4) and the value contains ':' we convert it.
        if (CT == 4 && value.includes(":")) {
            return this.getTimeInSeconds(value);
        }

        // If the metric is a percentage (ConversionType = 5)
        //the previous calculation is kept.
        if (CT == 5) {
            return +value / 100;
        }

        //Otherwise, we return the value directly.
        return +value;
    }

  getFormattedMetric(value: number){
    if (this.gs.modified.item.SelectedMetrics == undefined)
      return this.formattedMetricPipe.transform(0, "");

    const CT = this.gs.modified.item.SelectedMetrics[0].conversionType;
    return this.formattedMetricPipe.transform(+value, CT);
  }

  /**
   * Get the step value will be incremented the Val2 subsequents rings
   */
    getRingsStep() {
        let step = 0.01; // Adjusted to always be positive

        const ConversionTypeBasedStep = {
            '4': 1,  // For time, the increase is in seconds
            '5': 0.0001  // For percentages, a small jump
        };

        const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;

        if (this.gs.modified.item.SelectedMetrics != null &&
            this.gs.modified.item.SelectedMetrics.length > 0 &&
            Object.keys(ConversionTypeBasedStep).includes(conversionType)) {
            step = ConversionTypeBasedStep[conversionType];
        }

        if (this.rings != null &&
            this.rings.length > 0 &&
            this.rings[0].ComparisonType == "4") {
            step *= -1;
        }

        return step;
    } 

  addOffset (conversionType: string, value: number) {
    switch (conversionType) {
      case "1": //Second
      case "2": //Minute
      case "3": //Hour
      case "4": //Time   
      return value + 0.01;
      case "5": //Percent
      return +(value + 0.01).toFixed(2);
      default:
        return +(value + 0.01).toFixed(2);
    }
  }

  substractOffset (conversionType: string, value: number) {
    switch (conversionType) {
      case "1": //Second
      case "2": //Minute
      case "3": //Hour
      case "4": //Time   
      return value - 0.01;
      case "5": //Percent
      return +(value - 0.01).toFixed(2);
      default:
        return +(value - 0.01).toFixed(2);
    }
  }


  /**
   * Evaluates two rings value and determinates wich value is accepted depending on the
   * comparison type selected in the game.
   * If the comparison is "Greater than" and current ring value is higher than prev ring value or
   * if the comparison is "Lower than" and current ring value is lower than prev ring value, lower limit will be returned,
   * otherwise the current ring value is accepted and returned
   * 
   * @param prevRingValue 
   * @param currentRingValue 
   * @param numeric If true, fn will return the numeric format of value, using this.getRingNumericValue
   * @returns 
   */
  getRingLimitValue (prevRingValue: number, currentRingValue: number, currentValue2: number) {
        const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType;
        const comparisonType = this.rings[0].ComparisonType as ComparisonType.GreaterThan | ComparisonType.LessThan;
        const initialValue = this.rings[0].Target.Val1;
        const isLessThan = comparisonType === ComparisonType.LessThan;
        const isGreaterThan = comparisonType === ComparisonType.GreaterThan;
        const modifyValue1 = isLessThan ? this.addOffset(conversionType, currentValue2) : this.substractOffset(conversionType, currentValue2);

        // If the comparison is 1 (Greater than) and current ring value is higher than prev ring value or
        // if the comparison is 2 (Lower than) and current ring value is lower than prev ring value, lower limit should be returned
        const correctLimitLessThan = isLessThan && (currentRingValue > initialValue && currentRingValue > currentValue2);
        const correctLimitGreaterThan = isGreaterThan && (currentRingValue < initialValue && currentRingValue < currentValue2);
        const isInLimitRange = correctLimitLessThan || correctLimitGreaterThan;

        if (isInLimitRange) {
            return currentRingValue;
        }

        if (conversionType === '1' || conversionType === '2' || conversionType === '3' || conversionType === '4') {
            const modifiedValue = isLessThan ? this.addOffset(conversionType, currentValue2) : this.substractOffset(conversionType, currentValue2);
            return modifiedValue;
        }
        return currentValue2;
    }

  isValidRingValue (value: string) {
    const conversionType = this.gs.modified.item.SelectedMetrics[0].conversionType
    const isNumeric = /^(\d+(\.\d{1,})?)/g.test(value);
    const isFullTime = /^\d+:\d+:\d+$/g.test(value);
    return conversionType == "4" ? isFullTime : isNumeric;
  }

  goToRules(): void {
    window.open(_BaseURI + "/Goals/Rules.aspx", "_blank");
  }

  closeModalInfo(): void {
    this.navigationService.showOverlay = false;
    this.modalReference.close();
  }

  //Events
  private onMetricClicked = (args) => {
    //Make sure that this name matches the one specified in the file "GamesAddEditConfigureChooseMetrics.js" (this.metricsSource)!
    // if (args.source !== "General Choose Metrics") return false; 
    if (this.rings != null && this.rings.length > 0 && this.gs.modified.item.SelectedMetrics != null && this.gs.modified.item.SelectedMetrics.length > 0) {
      if (this.gs.modified.item.SelectedMetrics[0].direction == "0")
        this.rings[0].ComparisonType = "2"; //Less than since the metric direction is down
      else if (this.gs.modified.item.SelectedMetrics[0].direction == "1")
        this.rings[0].ComparisonType = "1"; //Greater than since the metric direction is up
    }

    this._setAllVal1FieldsToZero();
  }
}

type Reward = {
  editing: boolean;
  rewardType: number;
  rewardValue: number;
};

type Ring = {
  Coins: Reward;
  XP: Reward;
  Currency: Reward;
  Badge: Reward;
  Target: {
    Val1: number,
    Val2: number
  };
  ComparisonType: string;
}

enum ComparisonType {
  GreaterThan = '1',
  LessThan = '2',
  Between = '3'
}
